import $ from 'jquery';

const Header = () => {
    const $siteHeader = $('#siteHeader');

    const init = () => {
        if (!$siteHeader.length) {
            return;
        }
    }

    return Object.freeze({ init });
};

export default Header;